import React from "react";
import PropTypes from "prop-types";
import {
    ajaxErrorHandler,
    baseValue,
    dateRender,
    defaultSuccess
} from "../../../libs/utils";
import ListView from "../../../base/ListView";
import {selectCompany} from "../../../redux/preferences/selectors";
import {connect} from "react-redux";
import {
    deleteCompanyUser,
    getUsersForCurrentUser
} from "../../../services/api/users";
import {toImmutable} from "../../../libs/immutable-transformer";
import AdminSubHeader from "../../layouts/partials/AdminSubheader";
import {Link, NavLink} from "react-router-dom";
import Confirm from "../../../base/Confirm";
import {selectUser} from "../../../redux/auth/selectors";
import {getSetting} from "../../../services/api/settings";
import {Trans} from "react-i18next";

function ListViewCustomLinks({user}) {
    let buttons = [];

    buttons.push(
        <NavLink
            to={`/company/employees/${user.id}/certificates`}
            className="btn btn-outline-accent m-btn btn-sm  m-btn--icon m--margin-left-5"
        >
            <span>
                <i className="la la-certificate"/>
                <span>Certificates</span>
            </span>
        </NavLink>
    )

    return buttons;
}

class _CompanyEmployeesList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            users: [],
            usersMeta: {},
            baseFilters: toImmutable({}),
            allowCreation: false
        };

        this._handleFilterUpdate = this._handleFilterUpdate.bind(this);
        this._handleDelete = this._handleDelete.bind(this);
    }

    static propTypes = {
        company: PropTypes.object,
        user: PropTypes.object
    };

    UNSAFE_componentWillMount() {
        this._getUsers(this.state.baseFilters);

        getSetting("allow_company_user_creation").then(response => {
            this.setState({
                allowCreation: response.value
            });
        });
    }

    _handleFilterUpdate(filters) {
        this._getUsers(filters);
    }

    _getUsers(filters) {
        getUsersForCurrentUser(this.props.company.id, filters).then(response => {
            this.setState({
                users: response.data,
                usersMeta: response.meta,
                baseFilters: filters
            });
        });
    }

    _handleDelete(id) {
        Confirm(
            "Are you sure you want to delete this Employee? This will not work when this employee has already been planned for an event.",
            {
                title: "Delete Employee",
                confirmStyle: "btn-danger",
                confirmText: "Delete"
            }
        ).then(
            result => {
                deleteCompanyUser(this.props.company.id, id)
                    .then(response => {
                        defaultSuccess("User has been deleted");
                        this._getUsers(this.state.baseFilters);
                    })
                    .catch(ajaxErrorHandler);
            },
            result => {
            }
        );
    }

    render() {
        const {users, usersMeta, baseFilters, allowCreation} = this.state;
        const listViewConf = {
            dataSet: users,
            dataMeta: usersMeta,
            customKey: "userId",
            columns: [
                {
                    key: "name",
                    value: "Name",
                    render: user =>
                        user.user.firstName + " " + baseValue(user.user.lastName)
                },
                {
                    key: "updatedAt",
                    value: "Last Updated",
                    sort: "updated_at",
                    render: user => dateRender(user.updatedAt)
                }
            ],
            baseFilters: baseFilters,
            filters: [
                {
                    label: "Name",
                    icon: "la-search",
                    type: "text",
                    key: "full_name"
                }
            ],
            actions: {
                deleteLink: true,
                deleteHideFunction: item => item.id === this.props.user.id,
                editLink: allowCreation,
                detailsLink: false,

                deleteFunction: this._handleDelete,
                customLink: item => <ListViewCustomLinks user={item} currentUser={this.props.user}/>
            },
            url: "employees"
        };

        return [
            <AdminSubHeader title="Employees" key="subheader" breadcrumbs={[]}>
                {allowCreation && (
                    <Link
                        to="/company/employees/nin"
                        className="btn btn-outline-success m-btn m-btn--icon btn-lg m-btn--icon-only m-btn--pill m-btn--air"
                    >
                        <i className="la la-plus"/>
                    </Link>
                )}
            </AdminSubHeader>,
            <div className="m-content" key="content">
                {!allowCreation && (
                    <div className="alert alert-warning">
                        <Trans>creatingNotAllowedMsg</Trans>
                    </div>
                )}
                <div className="row">
                    <div className="col-xl-12">
                        <ListView
                            config={listViewConf}
                            handleDelete={this._handleDelete}
                            handleFilterUpdate={this._handleFilterUpdate}
                        />
                    </div>
                </div>
            </div>
        ];
    }
}

const mapDispatchToProps = dispatch => ({});

const mapStateToProps = function (state) {
    return {
        company: selectCompany(state),
        user: selectUser(state)
    };
};

const CompanyEmployeesList = connect(
    mapStateToProps,
    mapDispatchToProps
)(_CompanyEmployeesList);

export default CompanyEmployeesList;
